<button type="button" class="btn button" (mouseover)="setNgStyleOnhover()" (mouseleave)="setNgStyle()" [ngStyle]="ngStyle">{{text}}</button>
